module.exports = __webpack_public_path__ + "static/media/15e-01-HOME_ST-3-2015-1829x1372mm-oleo-sobre-madera.95f34db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15e/15e-01-HOME_ST-3-2015-1829x1372mm-oleo-sobre-madera.jpg
// module id = 170
// module chunks = 0